import { AlertTriangle } from "lucide-react";

const PRODUCTION_HOST = "app.besca.eu";

/**
 * Hinweis, dass Änderungen in der Vorschau-Umgebung NICHT in die Live-Version gelangen.
 * Wird ausschließlich außerhalb der Produktion (app.besca.eu) angezeigt.
 */
export function PreviewEnvNotice({ area = "Inhalte" }) {
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  if (host === PRODUCTION_HOST) return null;
  return (
    <div
      data-testid="preview-env-notice"
      className="flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900"
    >
      <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5 text-amber-600" />
      <div>
        <span className="font-medium">Vorschau-Umgebung – keine Live-Änderungen.</span>{" "}
        Änderungen an {area} wirken sich hier <strong>nicht</strong> auf die Live-Version
        (
        <a
          href="https://app.besca.eu"
          target="_blank"
          rel="noreferrer"
          className="underline font-medium"
        >
          app.besca.eu
        </a>
        ) aus. Bitte nehmen Sie {area}-Änderungen direkt in der Live-Version vor.
      </div>
    </div>
  );
}
